import React from 'react';
import InfoCard from '../../../../common/InfoCard/InfoCard';
import styles from './index.module.scss';

const LifeCycleCard = ({ title, name, action }) => {
  return (
    <InfoCard dark={false} title={title} action={action}>
      <p className={styles.content}>{name}</p>
    </InfoCard>
  );
};

export default LifeCycleCard;
